import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import CardPage from '../../../commonModules/layouts/CardPage';
import { BreadCrumb } from './containers/Layout';
import Spin from '../../../commonModules/interface/Spin';
import {  Button, Grid } from '@material-ui/core';
import ClientPopUp from './clients/ClientPopUp';
import ListClient from './clients/ListClient';
import SwipeableTabs from '../../../commonModules/MUI/SwipeableTabs';
import FormClientUpdate from './clients/FormClientUpdate';
import FormClientNew from './clients/FormClientNew';
import InputText from '../../../commonModules/interface/form-input-inline';
import AccordionFilter from './Filter/AccordionFilter';

class Clients extends Component {
    state = {
        pageOfItems:[],
        currentPage:0,
        rowsPerPage:20,

        view : this.props.new ? "new" : "list",

        breadcrumb:"",
        update:false,
        sending: false,
        photos:{},
        reloadPagination: false,
        singleClient:{},
        searchClient: "",
        searchCliID: "",
        searchCity: "",
        single:{
            id: "",
            name: ""
        },
        singleCity: "",
    }
    
    // CLEAR & DISPLAY
        
        handleSingle = (client) => {
            this.setState({
                breadcrumb: client.name,
                singleClient:client,
                view: "client"
            })
        }
        handleUpdate = (client) => {
            console.log("in handle update")
            this.setState({
                breadcrumb: client.client_firstname + " " + client.client_lastname + " / Modifier",
                singleClient: client,
                oldClient: client,
                view: "update"
            })
            return
        }
        handleNew = () => {
            this.setState({view: "new", breadcrumb: "Nouveau"})
        }
        
        handleSelect = (option, name) => {
            this.setState({
                [name]: option.value, 
                currentPage: 0,
                currentPageProd: 0,
            })
        }
        handleChange = (e) => {
            const { name, value } = e.target;
            this.setState({
                [name]: value,
                currentPage: 0,
                currentPageProd: 0,
            })
        }

        handleClose = () => {
            console.log("[DEBUG] CLIENTS HANDLE CLOSE")
            this.setState({
                singleClient:{},
                singleCity:"",
                openCity: false,
                view: "list",
                breadcrumb:"",
            });
        }
        
    onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        // update state with new page of items
        this.setState({ pageOfItems, currentPage, rowsPerPage });
    }
    getFilteredList = () => {
        const { searchClient, searchCliID, searchCity } = this.state;
        const { CLIENTS } = this.props;
        
        let list = Object.values(CLIENTS)
       
        // client
        if (!isEmpty(searchClient)) {
            list = list.filter(item => item.client_ref === searchClient || item.sale_paygo_id === searchClient )
        }
        if(!isEmpty(searchCliID)){
            list = list.filter(item => item.id && item.id.toLowerCase().indexOf(searchCliID.toLocaleLowerCase()) > -1 || item.client_lastname && item.client_lastname.toLowerCase().indexOf(searchCliID.toLocaleLowerCase()) > -1 || item.client_firstname && item.client_firstname.toLowerCase().indexOf(searchCliID.toLocaleLowerCase()) > -1 )
        }
        if(!isEmpty(searchCity)){
            list = list.filter(item => item.client_city && item.client_city.toLowerCase().indexOf(searchCity.toLocaleLowerCase()) > -1 )
        }
       
        return list
    }

    createClientOptionList = () => {
        const list = [{value: "", label: "Tous les Clients"}]
        const { CLIENTS } = this.props
        if( CLIENTS ){
            Object.values(CLIENTS).map(client => { 
                list.push (       
                    {value:client.id, label:client.client_lastname} 
                )
            })
        } 
        return list
    }
    
    render() {
        let clients = this.createClientOptionList()
        return (
            <CardPage 
                title="Clients"
                storehouse
                action={
                    <div>
                        {this.state.view ==="list" &&
                        <Button 
                            variant="contained"
                            color="primary"
                            onClick={ this.handleNew }
                        >
                            Nouveau
                        </Button>
                        }
                        {this.state.view === "client" &&
                            <Button 
                                variant="contained"
                                color="secondary"
                                onClick={() => this.handleUpdate(this.state.singleClient)}
                            >
                                Modifier
                            </Button>
                        }
                    </div>
                }
            >
                {this.state.sending && <Spin />}
                
                <BreadCrumb breadcrumb={ this.state.breadcrumb } title="Clients" back={this.handleClose} />
                {this.state.view === "new" &&
                    <FormClientNew 
                        {...this.props} // notif from here
                        handleClose={this.handleClose} 
                    />
                } 
                {this.state.view === "update" &&
                    <FormClientUpdate
                        {...this.props} // notif from here
                        closePopUp={this.handleClose} 
                        client={this.state.singleClient} 
                        // oldClient={this.state.oldClient} 
                        update={this.state.view === "update"} 
                    />
                }
                {this.state.view === "client" &&
                    <ClientPopUp 
                        {...this.props} 
                        closePopUp={this.handleClose}
                        client={this.state.singleClient}
                        update={this.handleUpdate}
                    />
                }
                {/* <Box p={2}> */}
                    <AccordionFilter>
                        <Grid container spacing={1}>
                            {/*<Grid item xs={12} md={6}>
                                <InputSelect
                                    options={clients}
                                    value={this.state.searchClient}
                                    label="Client"
                                    onChange={(option) => this.handleSelect(option, "searchClient") }
                                /> 
            </Grid>*/}
                            <Grid item xs={12} md={6}>
                                <InputText
                                    label="Recherche Client"
                                    value={this.state.searchCliID}
                                    name="searchCliID"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputText
                                    label="Recherche Ville"
                                    value={this.state.searchCity}
                                    name="searchCity"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                        </Grid>
                    </AccordionFilter>
                {/* </Box>           */}
                {this.state.view === "list" &&

                    <SwipeableTabs
                        labels={["Clients"]}
                        default="Clients"
                    >
                        <ListClient 
                            {...this.props}
                            {...this.state}
                            onChangePage={this.onChangePage}
                            handleSelect={this.handleSelect}
                            handleSingle={this.handleSingle}
                            handleNew={this.handleNew}
                            handleUpdate={this.handleUpdate}
                            getFilteredList={this.getFilteredList} 
                        />
                    </SwipeableTabs>
                }
            </CardPage>
                
        );
    }
}

export default Clients;
// export default connect(, )(Clients);